// import { createSlice } from "@reduxjs/toolkit";
// import { fetchLikesByPost, fetchLikeStatus, toggleLike } from "../thunks/likesThunks";

// const initialState = {
//   // posts[postId] = { count: number, users: [] }
//   posts: {},
//   // status[postId] = { liked: boolean, count: number }
//   status: {},
//   loading: false,
//   error: null,
// };

// const likesSlice = createSlice({
//   name: "likes",
//   initialState,
//   reducers: {
//     // optional optimistic update
//     setOptimisticLike(state, action) {
//       const { postId, liked } = action.payload;
//       const prev = state.status[postId] || { liked: false, count: 0 };
//       state.status[postId] = {
//         liked,
//         count: liked ? prev.count + 1 : Math.max(0, prev.count - 1),
//       };
//     },
//     clearLikesState(state) {
//       state.posts = {};
//       state.status = {};
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // fetch likes for a post
//       .addCase(fetchLikesByPost.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLikesByPost.fulfilled, (state, action) => {
//         state.loading = false;
//         const { postId, count, users } = action.payload;
//         const pid = String(postId || '').trim();
//         if (!pid) return;
//         state.posts[pid] = { count: count ?? 0, users: users ?? [] };
//       })
//       .addCase(fetchLikesByPost.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error?.message || "Failed to load likes";
//       })

//       // fetch status
//       .addCase(fetchLikeStatus.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLikeStatus.fulfilled, (state, action) => {
//         state.loading = false;
//         const { postId, status } = action.payload;
//         const pid = String(postId || '').trim();
//         if (!pid) return;
//         state.status[pid] = status ?? { liked: false, count: 0 };
//       })
//       .addCase(fetchLikeStatus.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error?.message || "Failed to get like status";
//       })

//       // toggle like
//       .addCase(toggleLike.pending, (state) => {
//         state.error = null;
//       })
//       .addCase(toggleLike.fulfilled, (state, action) => {
//         const { postId, status } = action.payload;
//         state.status[postId] = status ?? state.status[postId] ?? { liked: false, count: 0 };
//         // optionally update posts[postId].count to keep UI consistent
//         if (state.posts[postId]) state.posts[postId].count = state.status[postId].count;
//       })
//       .addCase(toggleLike.rejected, (state, action) => {
//         state.error = action.error?.message || "Failed to toggle like";
//       });
//   },
// });

// export const { setOptimisticLike, clearLikesState } = likesSlice.actions;
// export default likesSlice.reducer;



// import { createSlice } from "@reduxjs/toolkit";
// import { fetchLikesByPost, fetchLikeStatus, toggleLike } from "../thunks/likesThunks";

// const initialState = {
//   // posts[postId] = { count: number, users: [] }
//   posts: {},
//   // status[postId] = { liked: boolean, count: number }
//   status: {},
//   loading: false,
//   error: null,
// };

// const likesSlice = createSlice({
//   name: "likes",
//   initialState,
//   reducers: {
//     // optional optimistic update
//     setOptimisticLike(state, action) {
//       const { postId, liked } = action.payload;
//       const prev = state.status[postId] || { liked: false, count: 0 };
//       state.status[postId] = {
//         liked,
//         count: liked ? prev.count + 1 : Math.max(0, prev.count - 1),
//       };
//     },
//     clearLikesState(state) {
//       state.posts = {};
//       state.status = {};
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // fetch likes for a post
//       .addCase(fetchLikesByPost.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLikesByPost.fulfilled, (state, action) => {
//         state.loading = false;
//         const { postId, count, users } = action.payload;
//         const pid = String(postId || "").trim();
//         if (!pid) return;
//         state.posts[pid] = { count: count ?? 0, users: users ?? [] };
//       })
//       .addCase(fetchLikesByPost.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error?.message || "Failed to load likes";
//       })

//       // fetch status
//       .addCase(fetchLikeStatus.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLikeStatus.fulfilled, (state, action) => {
//         state.loading = false;
//         const { postId, status } = action.payload;
//         const pid = String(postId || "").trim();
//         if (!pid) return;
//         state.status[pid] = status ?? { liked: false, count: 0 };
//       })
//       .addCase(fetchLikeStatus.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error?.message || "Failed to get like status";
//       })

//       // toggle like
//       .addCase(toggleLike.pending, (state) => {
//         state.error = null;
//       })
//       .addCase(toggleLike.fulfilled, (state, action) => {
//         const { postId, status } = action.payload;
//         state.status[postId] = status ?? state.status[postId] ?? { liked: false, count: 0 };
//         if (state.posts[postId]) state.posts[postId].count = state.status[postId].count;
//       })
//       .addCase(toggleLike.rejected, (state, action) => {
//         state.error = action.error?.message || "Failed to toggle like";
//       });
//   },
// });

// export const { setOptimisticLike, clearLikesState } = likesSlice.actions;
// export default likesSlice.reducer;


// =======================================
// frontend/src/Redux/slices/likesSlice.js
// FUSION des 2 versions (ton code commenté + ton code actuel)
// - normalise postId (trim) partout
// - optimistic update + clear
// - maj posts[postId].count après status/toggle pour cohérence UI
// =======================================
import { createSlice } from "@reduxjs/toolkit";
import { fetchLikesByPost, fetchLikeStatus, toggleLike } from "../thunks/likesThunks";

/* helper: normalize postId key */
const toKey = (v) => (v == null ? "" : String(v).trim());

const initialState = {
  // posts[postId] = { count: number, users: [] }
  posts: {},
  // status[postId] = { liked: boolean, count: number }
  status: {},
  previousStatus: {},
  loading: false,
  error: null,
};

const likesSlice = createSlice({
  name: "likes",
  initialState,
  reducers: {
    // optional optimistic update
    setOptimisticLike(state, action) {
      const pid = toKey(action.payload?.postId);
      const liked = !!action.payload?.liked;
      if (!pid) return;

      const prev = state.status[pid] || { liked: false, count: 0 };

      state.status[pid] = {
        liked,
        count: liked ? (prev.count ?? 0) + 1 : Math.max(0, (prev.count ?? 0) - 1),
      };

      // keep aggregate coherent
      if (state.posts[pid]) {
        state.posts[pid].count = state.status[pid].count;
      }
    },

    clearLikesState(state) {
      state.posts = {};
      state.status = {};
      state.previousStatus = {};
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // =========================
      // fetch likes for a post
      // =========================
      .addCase(fetchLikesByPost.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLikesByPost.fulfilled, (state, action) => {
        state.loading = false;

        const pid = toKey(action.payload?.postId);
        if (!pid) return;

        const count = action.payload?.count ?? 0;
        const users = action.payload?.users ?? [];

        state.posts[pid] = { count, users };

        // optional: sync status count if exists
        if (state.status[pid]) {
          state.status[pid].count = count;
        }
      })
      .addCase(fetchLikesByPost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to load likes";
      })

      // =========================
      // fetch status
      // =========================
      .addCase(fetchLikeStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLikeStatus.fulfilled, (state, action) => {
        state.loading = false;

        const pid = toKey(action.payload?.postId);
        if (!pid) return;

        const st = action.payload?.status ?? { liked: false, count: 0 };

        state.status[pid] = {
          liked: !!st.liked,
          count: st.count ?? 0,
        };

        // keep aggregate coherent
        if (state.posts[pid]) {
          state.posts[pid].count = state.status[pid].count;
        }
      })
      .addCase(fetchLikeStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to get like status";
      })

      // =========================
      // toggle like
      // =========================
      .addCase(toggleLike.pending, (state, action) => {
        state.error = null;
        const pid = toKey(action.meta?.arg?.postId);
        if (!pid) return;

        const previous = state.status[pid] || { liked: false, count: 0 };
        state.previousStatus[pid] = { ...previous };
        state.status[pid] = {
          liked: !previous.liked,
          count: previous.liked
            ? Math.max(0, (previous.count ?? 0) - 1)
            : (previous.count ?? 0) + 1,
        };
        if (state.posts[pid]) {
          state.posts[pid].count = state.status[pid].count;
        }
      })
      .addCase(toggleLike.fulfilled, (state, action) => {
        const pid = toKey(action.payload?.postId);
        if (!pid) return;

        const st =
          action.payload?.status ??
          state.status[pid] ??
          { liked: false, count: 0 };

        state.status[pid] = {
          liked: !!st.liked,
          count: st.count ?? 0,
        };

        // optionally update posts[pid].count to keep UI consistent
        if (state.posts[pid]) {
          state.posts[pid].count = state.status[pid].count;
        }
        delete state.previousStatus[pid];
      })
      .addCase(toggleLike.rejected, (state, action) => {
        const pid = toKey(action.meta?.arg?.postId);
        const previous = pid ? state.previousStatus[pid] : undefined;
        if (pid && previous) {
          state.status[pid] = previous;
          if (state.posts[pid]) state.posts[pid].count = previous.count;
          delete state.previousStatus[pid];
        }
        state.error = action.error?.message || "Failed to toggle like";
      });
  },
});

export const { setOptimisticLike, clearLikesState } = likesSlice.actions;
export default likesSlice.reducer;
